<div class="card-item-snake-top-arrow"></div>
<div class="card-item-snake-top-info-box">
  @if (completed()) {
    <div class="completed-box">
      <ptl-icon [icon]="LucideCheck" [size]="'s'" [strokeWidth]="3"></ptl-icon>
    </div>
  } @else if (engaged()) {
    <div class="started-box"></div>
  } @else {
    <div class="not-started-box"></div>
  }
</div>

<ptl-v3-content-card [item]="cardItem()" [reserveRows]="reservedRows()" (cardClicked)="onCardOpen()"></ptl-v3-content-card>
